import React from 'react'
import classes from './LoadingPage.module.css'
import { Center } from '@chakra-ui/react'
import UmSpinner from '../../components/UI/UmSpinner'

function LoadingPage() {
    return (
        <Center className={classes.container}>
            <UmSpinner />
        </Center>
    )
}

export default LoadingPage
